"use client";

import React from "react";
import { ShareButton } from "./share-button";
import { getCookie } from "cookies-next";
import {
  PostHostEventsEnum,
  sendPostHogEvent,
} from "../../../../libs/post-hog/post-hog-send-event";

type ShareButtonWrapperProps = {
  post: any;
};

export default function ShareButtonWrapper({ post }: ShareButtonWrapperProps) {
  const handleShareEvent = async () => {
    const email = (await getCookie("leadEmail")) ?? undefined;
    sendPostHogEvent({
      eventName: PostHostEventsEnum.SHARE_BLOG_POST,
      email,
      eventProperties: {
        ref: "Share Blog Post",
        email,
        ...post,
      },
    });
  };

  return (
    <ShareButton
      title={post.title}
      text="Da uma olhada nesse post incrível que encontrei no Click Autos!"
      onShare={handleShareEvent}
    />
  );
}
